<sc-padding>

  <app-gate-keeper-control-find-element-by-qr-camera-picker (deviceSelected)="onDeviceSelected($event)" />

  <div class="screen">
    <sc-loading-spinner fitHeight [isLoading]="isLoading">
      <video #camera autoplay playsinline muted></video>
      <canvas #canvasRef style="display: none;"></canvas>
    </sc-loading-spinner>
  </div>
</sc-padding>